// features/user/userApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const SliderApi = createApi({
  reducerPath: "SliderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "slider",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSlider: builder.query({
      query: (query) => ({
        url: query ? `?page=${query}` : "",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetSliderQuery } = SliderApi;
// for use just enter the page name